import { type FC, type MouseEvent, useMemo } from 'react';

import { Box, Button, IconButton } from '@mui/material';
import { ChevronDownIcon, ChevronLeft, ChevronRight } from 'lucide-react';

import { useReportContext } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { useLocale } from '@shared/hooks/locale';

type MobileStepperHeaderProps = {
  handleMenuClick: (event: MouseEvent<HTMLButtonElement>) => void;
  onPreviousStep: () => void;
  onNextStep: () => void;
};

const MobileStepperHeader: FC<MobileStepperHeaderProps> = ({
  handleMenuClick,
  onPreviousStep,
  onNextStep,
}) => {
  const { currentStepIndex, currentStepData } = useReportContext();
  const { t } = useLocale();

  const isPageFooterStep = useMemo(
    () => currentStepData.pageId === 'page-share',
    [currentStepData.pageId],
  );

  const isFirstStep = useMemo(() => currentStepIndex === 0, [currentStepIndex]);

  return (
    <>
      {!isPageFooterStep ? (
        <IconButton onClick={onPreviousStep} disabled={isFirstStep}>
          <ChevronLeft size={20} />
        </IconButton>
      ) : (
        <Box />
      )}
      <Button
        variant="text"
        onClick={handleMenuClick}
        sx={{
          color: 'text.primary',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {currentStepData.title}
        <ChevronDownIcon size={18} />
        {'active' in currentStepData && !currentStepData.active && (
          <span style={{ fontSize: '0.75rem', opacity: 0.5 }}>
            ({t('HIDDEN')})
          </span>
        )}
      </Button>
      {!isPageFooterStep ? (
        <IconButton onClick={onNextStep}>
          <ChevronRight size={20} />
        </IconButton>
      ) : (
        <Box />
      )}
    </>
  );
};

export default MobileStepperHeader;
